import { BackgammonLobby } from '@/components/backgammon/BackgammonLobby';

/**
 * Hub "Gioca" section for Backgammon: the full lobby (ranked, match length,
 * vs bot, friend invite, accept code) minus the leaderboard peek — the Hub
 * has a dedicated Classifica section. ownScroll panel; `-mx-4` cancels the
 * lobby's own px-4 against the Hub wrapper (same as QcpPlayPanel / EventsPanel).
 */
export function QgammonPlayPanel() {
  return (
    <div className="-mx-4 min-h-0 flex-1 overflow-y-auto">
      <BackgammonLobby showLeaderboard={false} />
    </div>
  );
}
